/* LinksComponent.js */

"use strict";
const _ = require("lodash");
const DefaultColumnComponent = require("@gluenetworks/steve_ui_widgets").GridGl
    .DefaultColumnComponent;
const SteveIo = require("@gluenetworks/steve_core_io");
const Renderer = require("./LinksRenderer");

class LinksComponent extends DefaultColumnComponent {
    constructor(value, context) {
        super();
        this._gameEditor = context.gameEditor;
        this._triggerType = context.triggerType;
        this._logger = context.logger;
        this._value = value;
        this._renderer = new Renderer(this);
        this._steveIo = new SteveIo();
        this._userSession = context.userSession;
        this._modalUserFeedback = context.MUF;
        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {
        if (this._value) {
            this._value.on(
                "PropertiesUpdated",
                (this.updateComponent = this.updateComponent.bind(this))
            );
        }
    }

    _unregisterListeners() {
        if (this._value) {
            this._value.removeListener("PropertiesUpdated", this.updateComponent);
        }
    }

    _hasAccessToDownload() {
        return !!_.get(this._userSession._userEntity, "authorizedActions", []).filter(
            (action) => action === "provisionLogRead"
        ).length;
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    get hasPermissions() {
        return this._hasAccessToDownload();
    }
    shutdown() {
        this._unregisterListeners();
        let prom = this._renderer._shutdown();
        this._renderer = undefined;
        this._value = undefined;
        this._steveIo = undefined;
        return prom;
    }

    /******************************************/
    /* START PUBLIC API METHODS               */
    /******************************************/

    setValue(newVal) {
        if (!_.isUndefined(newVal)) {
            this.setLinks(newVal);
        }
    }

    getValue() {
        return this.getLinks();
    }

    updateComponent() {
        this.emit("Links", this._value);
    }

    setLinks(newVal) {
        this._value = newVal;
        this.emit("Links", newVal);
    }

    getLinks() {
        return this._value;
    }

    /******************************************/
    /* END PUBLIC API METHODS                 */
    /******************************************/

    downloadWorkReport() {
        if (!this.hasPermissions) {
            return Promise.reject({errorCode: "NotAuthorized"});
        } else {
            return this._value.generateWorkReports().then((reports) => {
                if (_.isEmpty(reports)) {
                    return Promise.reject({errorCode: "WorkErrorRetrieval"});
                }
                if (Object.values(reports).length === 1) {
                    let report = Object.values(reports)[0];
                    let fileName = `Work-Result-Report-${_.replace(
                        this._triggerType.displayName,
                        /\s/g,
                        "-"
                    )}-${new Date().toISOString()}.csv`;
                    let file = new this._steveIo.File(fileName, null, report.contents);
                    this._steveIo.fileFactory.saveFile(file);
                } else {
                    const fileConfig = {},
                        fileName = "Work_Result_Reports.zip";
                    let type = "text/plain";

                    Object.values(reports).forEach(({name, reportType, contents}) => {
                        if (reportType === "json") {
                            type = "text/json";
                            contents = JSON.stringify(contents, null, "\t");
                        }
                        fileConfig[`${name.replace(/[/,: ]/g, "_")}.${reportType}`] = {
                            type,
                            content: contents,
                        };
                    });
                    this._steveIo.fileFactory.saveStringsAsZip(fileConfig, fileName);
                }
                return Promise.resolve();
            });
        }
    }
}

module.exports = LinksComponent;
